module.exports = __webpack_public_path__ + "img/logo.e0a28899.png";